import { DatePipe } from "@angular/common";
import Swal from "sweetalert2";
import htmlToPdfmake from 'html-to-pdfmake';
import { FormArray, FormGroup } from "@angular/forms";
import { DataTableEventConfig } from "./interface";

export function filterByName(
  moduleName: string,
  event: any,
  afs: any,
  accountFirebase: any,
  passID: any
) {
  let query;
  // Check if the name filter exists and apply it to the query
  if (event.target.value.length > 0) {
    query = afs
      .collection("/accounts")
      .doc(accountFirebase)
      .collection("/variations", (ref:any) =>
        ref
          .where("projectId", "==", passID.id)
          .where("variationsName", "==", event.target.value)
          // .where("variationsName", "==", event.target.value + '\uf8ff') // For case-insensitive search
          // .orderBy("variationsName") // First order by "name" since we're filtering it with an inequality
          // .orderBy("variantsNumber", 'desc') // Then order by "variantsNumber" for descending order
          .limit(10)
      );
    `                   `;
  } else {
    // If no name filter is applied, fallback to a default query
    query = afs
      .collection("/accounts")
      .doc(accountFirebase)
      .collection("/variations", (ref:any) =>
        ref
          .where("projectId", "==", passID.id)
          .orderBy("variantsNumber", "desc") // For ordering variations by number or any other criteria
          .limit(10)
      );
  }
  return query;
}

export function createExpandableRow(cell: HTMLElement, createdAt: any) {

  if (!createdAt) {
    cell.innerHTML = "N/A";
    return;
  }

  const date = createdAt.toDate();

  const formattedDate = date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  // Create the expandable row
  const expandableRow = document.createElement("div");
  expandableRow.classList.add("expandable-row");
  expandableRow.setAttribute("title", "Click to expand");
  expandableRow.innerHTML = `<span class="fw-bold" style="cursor:pointer">${formattedDate}</span>`;

  let isExpanded = false;

  expandableRow.addEventListener("click", () => {
    isExpanded = !isExpanded;
    expandableRow.innerHTML = `<span class="fw-bold" style="cursor:pointer">${
      isExpanded ? date.toString() : formattedDate
    }</span>`;

    // Force tooltip update
    expandableRow.removeAttribute("title");
    setTimeout(() => {
      expandableRow.setAttribute(
        "title",
        isExpanded ? "Click to collapse" : "Click to expand"
      );
    }, 10);
  });

  cell.innerHTML = ""; // Clear the cell before appending
  cell.appendChild(expandableRow);
}

export function updateRecipients(
  data_api: any, // API service
  recipientIds: string[], // List of recipient IDs
  projectId: string, // Project ID
  spinnerService: any,
  type: string, // Spinner service
  onSuccessCallback: Function, // Callback on success (to be called after successful update)
  onErrorCallback: Function // Callback on error (to be called after error occurs)
): void {
  try {
    // Show spinner while making the API call
    spinnerService.show();

    // Call the API to update RFI recipients
    data_api
      .updateRecipientEmails(recipientIds, projectId, type)
      .then((res: any) => {
        if (res.success) {
          onSuccessCallback(res); // Call the success callback
        }

        spinnerService.hide(); // Hide spinner after the operation
      })
      .catch((error:any) => {
        onErrorCallback(error); // Call the error callback
        spinnerService.hide(); // Hide spinner on error
      });
  } catch (error) {
    onErrorCallback(error); // Call the error callback
    spinnerService.hide(); // Hide spinner on error
  }
}

// CHECK EMAIL VALIDATION

export function checkValidEmail(input:any, Swal:any) {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i;

  if (!emailPattern.test(input)) {
    Swal.fire({
      title: "Please Enter Valid Email!",
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-success",
      },
      icon: "error",
    });
    return false;
  }
  return true;
}

// CHANGE TABLE LIMIT FUNCTION

export async function changeTableLimit(
  serviceFile,
  currentUserEmail,
  length,
  spinnerService,
  moduleName
) {
  try {
    spinnerService.show();
    await serviceFile.changeTableLimit(currentUserEmail, length, moduleName);
  } catch (error) {
    console.error("Error changing table limit:", error);
  } finally {
    spinnerService.hide();
  }
}

export async function getTableLimit(
  serviceFile,
  currentUserEmail,
  moduleName,
  spinnerService?
) {
  try {
    // Fetch the table limit from your service
    spinnerService.show();
    const tableLimit = await serviceFile.getTableLimit(
      currentUserEmail,
      moduleName
    );
    return tableLimit;
  } catch (error) {
    console.error("error getting table limit");
  } finally {
    spinnerService.hide();
  }
}

// SWAL MESSAGE

export function showSuccessAlert(title: string, swalInstance: any): void {
  swalInstance.fire({
    title,
    icon: "success",
    buttonsStyling: false,
    customClass: {
      confirmButton: "btn btn-success",
    },
  });
}

export function showErrorAlert(message: string, swalInstance: any): void {
  swalInstance.fire({
    title: "Error",
    text: message,
    icon: "error",
    buttonsStyling: false,
    customClass: {
      confirmButton: "btn btn-danger",
    },
  });
}

export function showWarningAlert(message: string, swalInstance: any): void {
  swalInstance.fire({
    title: "Warning",
    text: message,
    icon: "warning",
    buttonsStyling: false,
    customClass: {
      confirmButton: "btn btn-warning",
    },
  });
}

export function stripHtmlTags(html: string): string {
  return html.replace(/<\/?[^>]+(>|$)/g, "");
}

export function formatUserRole(role:string) {
  if (role == "project_worker") {
    return "Project Worker";
  } else if (role == "project_supervisor") {
    return "Site Supervisor";
  } else if (role == "project_owner") {
    return "External User";
  } else if (role == "app_admin") {
    return "Administrator";
  } else if (role == "project_designer") {
    return "Designer";
  } else if (role == "project_architect") {
    return "Architect";
  } else if (role == "project_engineer") {
    return "Engineer";
  }
}

export function getUser() {
  const user = JSON.parse(localStorage.getItem("currentUser"));
  if (user) {
    return user;
  } else {
    console.error("No user details found in local storage");
    return null;
  }
}

export const USER_ROLES = { 
  DESIGNER: "project_designer",
  ARCHITECT: "project_architect",
  ENGINEER: "project_engineer",
  ADMIN: "app_admin",
  SUPERVISOR: "project_supervisor",
  WORKER: "project_worker",
};

export function showNotification(
  message:any,
  type = "success",
  icon = "notifications"
) {
  // @ts-ignore
  $.notify(
    {
      icon: icon,
      message: message,
    },
    {
      type: type,
      timer: 1000,
      placement: {
        from: "top",
        align: "center",
      },
      template: `
        <div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0} alert-with-icon" role="alert">
            <button mat-button type="button" aria-hidden="true" class="close" data-notify="dismiss">
                <i class="material-icons">close</i>
            </button>
            <i class="material-icons" data-notify="icon">{icon}</i>
            <span data-notify="title">{1}</span>
            <span data-notify="message">{2}</span>
            <div class="progress" data-notify="progressbar">
                <div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div>
            </div>
            <a href="{3}" target="{4}" data-notify="url"></a>
        </div>
        `,
    }
  );
}

export function getVariationTableColumns(
  passID?: any,
  onDelete?: (rowData: any) => void,
  usersArray?: any[]
): any[] {
  return [
    {
      title: "Actions",
      data: null,
       createdCell: (cell: HTMLElement, cellData: any, rowData: any) => {
          let html = `
            <a style="color: #000000; cursor:pointer;" href="#/variations/project/${rowData.projectId}/edit/${rowData.id}">
              <i class="material-icons" title="Edit">edit</i>
            </a>
            <a style="color: #000000; cursor:pointer;" target="_blank" href="${rowData.pdfLink}">
              <i class="material-icons" title="Download">download</i>
            </a>
          `;

          // Add delete only if onDelete exists
          if (onDelete) {
            html += `
              <a class="delete-btn" style="color: #000000; cursor:pointer;">
                <i class="material-icons" title="Delete">delete</i>
              </a>
            `;
          }

          cell.innerHTML = html;

          // Attach delete event listener if delete button is present
          if (onDelete) {
            cell.querySelector('.delete-btn')?.addEventListener('click', () => {
              onDelete(rowData);
            });
          }
      },
    },
    { title: "Variation No.", data: "variantsNumber" },
    { title: "Variation Name", data: "variationsName" },
    {
      title: "Total",
      data: null,
      render: (data:any) => getTotal(data.variationGroupArray) ? getTotal(data.variationGroupArray).toFixed(2) : '-',
    },
    {
      title: "Due Date",
      data: null,
      render: (data:any) =>
        data.dueDate ? data?.dueDate?.toDate().toDateString() : "",
    },
    { title: "Status", data: "status" },
    {
      title: "Created Date",
      data: null,
      render: (data:any) =>
        data.createdAt ? data.createdAt.toDate().toDateString() : "",
    },
    {
    title: 'Created By',
    data: null,
    render: ({ createdBy }:any) => {
      const user = usersArray?.find((u: any) => u.id === createdBy);
      return user ? `${user.userFirstName} ${user.userLastName}` : '--';
    }
  }
  ];
} 

/**
 * Format Firestore timestamp into a human-readable string
 * @param timestamp Firestore timestamp object { seconds, nanoseconds }
 * @returns formatted string e.g. "Just now", "5 min ago", "Aug 19, 2025"
 */
export function formatNotificationTime(timestamp: any): string {
  if (!timestamp?.seconds) return "--";

  const date = new Date(timestamp.seconds * 1000);
  const now = new Date();
  const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);

  if (diffInSeconds < 60) return "Just now";
  if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)} min ago`;
  if (diffInSeconds < 86400)
    return `${Math.floor(diffInSeconds / 3600)} hours ago`;

  // For older dates
  const datePipe = new DatePipe("en-US");
  return datePipe.transform(date, "MMM d, yyyy") || "--";
}

export function getRecipients(
  moduleName: string,
  moduleData: any,
  projectData: any,
  settingsData: any,
  users: any
): string[] {
  console.log("users", users);
  console.log("settingsdata", settingsData);
  console.log("moduleData", moduleData);
  if (moduleName === "Rfi") {

    if (settingsData && settingsData.rfiEmailRecipient) {
      return settingsData.rfiEmailRecipient
        .map((email: string) => {
          const user = users.find((u: any) => u.userEmail === email);
          if (!user) {
            showErrorAlert("Recipient not found", Swal);
            return null;
          }
          return user.id;
        })
        .filter((id: string | null) => id !== null);
    } else {
      return [
      ...(moduleData?.rfiRecipients || []),
      ...(moduleData?.rfiCCRecipients || []),
      ...(moduleData?.rfiBCCRecipients || [])
      ];
    }
  }
  if (moduleName === "Selection") {
    if (settingsData && settingsData.selEmailRecipient) {
      return settingsData.selEmailRecipient
        .map((email: string) => {
          const user = users.find((u: any) => u.userEmail === email);
          if (!user) {
            showErrorAlert("Recipient not found", Swal);
            return null;
          }
          return user.id;
        })
        .filter((id: string | null) => id !== null);
    } else {
      return projectData?.recipientVariation || [];
    }
  }
  if (moduleName === "Variation") {
    if (settingsData && settingsData.varEmailRecipient) {
      return settingsData.varEmailRecipient
        .map((email: string) => {
          const user = users.find((u: any) => u.userEmail === email);
          if (!user) {
            showErrorAlert("Recipient not found", Swal);
            return null;
          }
          return user.id;
        })
        .filter((id: string | null) => id !== null);
    } else {
      return projectData?.recipientVariation || [];
    }
  }
  return [];
}

// export function buildModuleLink(moduleName: string, projectData: any, moduleData: any): string {
//   if (!projectData || !moduleData) return '';
//   switch (moduleName) {
//     case 'Rfi':
//       return `/rfis/project/${projectData.id}/edit/${moduleData.id}`;
//     case 'Selection':
//       return `/selections/project/${projectData.id}/edit/${moduleData.id}`;
//     case 'Variation':
//       return `/variations/project/${projectData.id}/edit/${moduleData.id}`;
//     default:
//       return '';
//   }
// }
export function getSelectionTableColumns(
  passID?: { id: string },
  onDelete?: (rowData: any) => void,
  usersArray?: any[]
): any[] {
  return [
    {
      title: 'Actions',
      data: null,
      createdCell: (cell: HTMLElement, cellData: any, rowData: any) => {
      // if (passID) {
        let html = `
          <a style="color: #000000; cursor:pointer;" href="#/selections/project/${rowData.projectId}/edit/${rowData.id}">
            <i class="material-icons" title="Edit">edit</i>
          </a>
          <a style="color: #000000; cursor:pointer;" target="_blank" href="${rowData.pdfLink}">
            <i class="material-icons" title="Download">download</i>
          </a>
        `;

        // Add delete only if onDelete exists
        if (onDelete) {
          html += `
            <a class="delete-btn" style="color: #000000; cursor:pointer;">
              <i class="material-icons" title="Delete">delete</i>
            </a>
          `;
        }

        cell.innerHTML = html;

        // Attach delete event listener if delete button is present
        if (onDelete) {
          cell.querySelector('.delete-btn')?.addEventListener('click', () => {
            onDelete(rowData);
          });
        }
      // } 
      // else {
      //   cell.innerHTML = '-'; // Fallback if no passID
      // }
    },
    },
    { title: 'Selection No.', data: 'selectionNumber' },
    { title: 'Selection Name', data: 'selectionName' },
    {
      title: 'Total',
      data: null,
      render: (data:any) =>
      getTotal(data.selectionGroupArray) ? getTotal(data.selectionGroupArray).toFixed(2) : '-',
    },
    {
      title: 'Due Date',
      data: null,
      render: (data:any) =>
        data.dueDate ? data.dueDate.toDate().toDateString() : '',
    },
    { title: 'Status', data: 'status' },
    {
      title: 'Created Date',
      data: null,
      render: (data:any) =>
        data.createdAt ? data.createdAt.toDate().toDateString() : '',
    },
     {
    title: 'Created By',
    data: null,
    render: ({ createdBy }:any) => {
      const user = usersArray?.find((u: any) => u.id === createdBy);
      return user ? `${user.userFirstName} ${user.userLastName}` : '--';
    }
  }
  ];
}

export function getRfiTableColumns(
  passID?: { id: string },
  onDelete?: (rowData: any) => void,
  usersArray?: any[]
): any[] {
  return [
   {
      title: 'Actions',
      data: null,
      createdCell: (cell: HTMLElement, cellData: any, rowData: any) => {
      // if (passID) {
        let html = `
          <a style="color: #000000; cursor:pointer;" href="#/rfis/project/${rowData.projectId}/edit/${rowData.id}">
            <i class="material-icons" title="Edit">edit</i>
          </a>
          <a style="color: #000000; cursor:pointer;" target="_blank" href="${rowData.pdfLink}">
            <i class="material-icons" title="Download">download</i>
          </a>
        `;

        // Add delete only if onDelete exists
        if (onDelete) {
          html += `
            <a class="delete-btn" style="color: #000000; cursor:pointer;">
              <i class="material-icons" title="Delete">delete</i>
            </a>
          `;
        }

        cell.innerHTML = html;

        // Attach delete event listener if delete button is present
        if (onDelete) {
          cell.querySelector('.delete-btn')?.addEventListener('click', () => {
            onDelete(rowData);
          });
        }
      // } 
      // else {
      //   cell.innerHTML = '-'; // Fallback if no passID
      // }
    },
    },
    { title: 'RFI No.', data: 'rfiNumber',
     },
    { title: 'RFI Name',data: 'rfiName',
    },
    // { title: 'Total', data: null,
    //   render: (data)=>{
    //     return this.getTotal(data.rfiGroupArray);
    //   }
    //  },
    { title: 'Due Date', data: null,
      render: (data:any) =>{
        return data.dueDate ? data?.dueDate?.toDate().toDateString() : '';
      }
     },
    { title: 'Status', data: 'status' },
    { title: 'Created Date', data: null,
      render : (data:any)=>{
        return data.createdAt ? data.createdAt.toDate().toDateString() : '';
      }
     },
       {
    title: 'Created By',
    data: null,
    render: ({ createdBy }:any) => {
      const user = usersArray?.find((u: any) => u.id === createdBy);
      return user ? `${user.userFirstName} ${user.userLastName}` : '--';
    }
  },
     { title: 'Closed Date', data: null,
      render : (data:any)=>{
        return data.closedAt ? data.closedAt.toDate().toDateString() : '--';
      }
     },
  ];
}

function getTotal(array:any){
    let total = 0;
    for (let group of array) { 
      total = total + parseFloat(group.groupTotal)
    }
    return total;
  }


export function getLastComment(item: any): { author: string; text: string } | null {
  if (!item?.value?.itemComments?.length) {
    return null;
  }
  const last = item.value.itemComments[item.value.itemComments.length - 1];
  return { author: last.author, text: last.text };
}


// TIMESTAMP FUNCTION
export function formatTimestamp(timestamp: any): string {
  if (timestamp && typeof timestamp.toDate === 'function') {
    return timestamp.toDate().toLocaleString();
  } else if (timestamp instanceof Date) {
    return timestamp.toLocaleString();
  } else {
    return new Date(timestamp).toLocaleString();
  }
}


// CONVERT URL TO BASE64
export async function getBase64ImageFromUrl(imageUrl: string): Promise<string> {
  try {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error('Error converting image to base64:', error);
    throw error;
  }
}

export function checkGlobalBooleanVariationSettings(value:any){
      if( ((value == true) || (value == false)) && (value !== '') ){
        return true;
      }else{
        return false;
      }
  }


export function checkDigitNumbers(digit:any){
        if(digit < 1000){
          return digit.toString().padStart(4, '0');
        }else{
          return digit;
        }
    }

declare const $: any;
// export function showNotification(message: string, type: 'success' | 'warning' | 'error' = 'success'): void {
//   $.notify(
//     {
//       icon: 'notifications',
//       message
//     },
//     {
//       type,
//       timer: 1000,
//       placement: { from: 'top', align: 'center' },
//       template: `
//         <div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0} alert-with-icon" role="alert">
//           <button mat-button type="button" aria-hidden="true" class="close" data-notify="dismiss">
//             <i class="material-icons">close</i>
//           </button>
//           <i class="material-icons" data-notify="icon">notifications</i>
//           <span data-notify="message">{2}</span>
//         </div>
//       `
//     }
//   );
// }

export function  cleanChar(str:any){
if(str){
  return str.replace(/[^\x20-\x7E]/g, '') ;
}else{
  return;
}

}

export function splitArray(arr:any){
  if(arr){
      if(arr.length > 1){
        return arr.join(', ');
      }else{
        return arr;
      }
  }
}

export function isPageBreak(images:any){
    if(images.length > 0){
      return {text: '', pageBreak: 'after'};
    }else{
      return {}
    }
  }


export function getClosingMessage(closingMessage:any){
    if(closingMessage){
      return htmlToPdfmake(closingMessage);
    }else{
      return;
    }
    
}

export function  getOpeningMessage(openingMessage:any){
    if(openingMessage){
      return htmlToPdfmake(openingMessage);
    }else{
      return;
    }
    
}

export function scopeOfWorks(scopeOfWorks: string) {
  if (!scopeOfWorks) return;

  const body = htmlToPdfmake(scopeOfWorks);


  console.log("body of scope of works", body);


  // tighten spacing inside content
  body.forEach((item:any) => {
    if (!item.margin) item.margin = [0, 0, 0, 0];

    item.margin[1] = 0; // top
    item.margin[3] = 2; // bottom (tight)

    if (item.ul) {
      item.ul = item.ul.map((li:any) => ({
        ...li,
        margin: [0, 0, 0, 2]
      }));
    }
  });

  return {
    // ⬇️ SPACE AFTER SECTION (bottom margin)
    margin: [0, 0, 0, 12],

    stack: [
      { text: 'SCOPE OF WORKS :', style: 'fieldHeader', margin: [0, 0, 0, 4] },
      ...body
    ]
  };
}

export function getNotes(notes: string) {
  if (!notes) return;

  const body = htmlToPdfmake(notes);

  // tighten spacing for each paragraph / element
  body.forEach((item:any) => {
    if (!item.margin) item.margin = [0, 0, 0, 0];

    item.margin[1] = 0; // top
    item.margin[3] = 2; // bottom (tight)

    if (item.ul) {
      item.ul = item.ul.map((li:any) => ({
        ...li,
        margin: [0, 0, 0, 2]
      }));
    }
  });

  return {
    // space AFTER this section
    margin: [0, 0, 0, 12],

    stack: [
      { text: 'NOTES :', style: 'fieldHeader', margin: [0, 0, 0, 4] },
      ...body
    ]
  };
}


export function findInvalidControls(formGroup: FormGroup | FormArray, path: string = ''): string[] {
  let invalid: string[] = [];

  Object.keys(formGroup.controls).forEach((key) => {
    const control = formGroup.get(key);
    const controlPath = path ? `${path}.${key}` : key;

    if (control instanceof FormGroup || control instanceof FormArray) {
      invalid = invalid.concat(findInvalidControls(control, controlPath));
    } else if (control?.invalid) {
      invalid.push(controlPath);
    }
  });

  return invalid;
}


export function attachDataTableEventListeners<T>(config: DataTableEventConfig<T>): void {
  const { tableId, editHandler, deleteHandler, dataSource } = config;
  const table = $(`#${tableId}`);

  // Clean up old handlers
  table.off('click', '.edit-btn');
  table.off('click', '.delete-btn');

  // Edit handler
  if (editHandler) {
    table.on('click', '.edit-btn', (event:any) => {
      event.preventDefault();
      const id = $(event.currentTarget).data('id');
      const item = dataSource.find((x: any) => x.id === id);
      if (item) editHandler(item);
    });
  }

  // Delete handler
  if (deleteHandler) {
    table.on('click', '.delete-btn', (event:any) => {
      event.preventDefault();
      const id = $(event.currentTarget).data('id');
      const item = dataSource.find((x: any) => x.id === id);
      if (item) deleteHandler(item);
    });
  }
}

export function renderActionButtons(row: any): string {
  return `
    <a class="edit-btn" data-id="${row?.id || ''}" style="color:#000;cursor:pointer;">
      <i class="material-icons" title="Edit" style="font-size:13px;vertical-align:middle;">edit</i>
    </a>
    <a style="color:#000;cursor:pointer;" target="_blank" href="${row?.pdfLink || '#'}">
      <i class="material-icons" title="Download" style="font-size:13px;vertical-align:middle;">download</i>
    </a>
    <a class="delete-btn" data-id="${row?.id || ''}" style="color:#000;cursor:pointer;">
      <i class="material-icons" title="Delete" style="font-size:13px;vertical-align:middle;">delete</i>
    </a>
  `;
}

export function confirmDialog(options?: {
    title?: string;
    text?: string;
    confirmText?: string;
    cancelText?: string;
    icon?: 'warning' | 'question' | 'info' | 'error' | 'success';
  }): Promise<any> {
    const {
      title = 'Are you sure?',
      text = '',
      confirmText = 'Yes',
      cancelText = 'No',
      icon = 'question'
    } = options || {};

    return Swal.fire({
      title,
      text,
      icon,
      showCancelButton: true,
      reverseButtons: true,
      buttonsStyling: false,
      customClass: {
        confirmButton: 'btn dcb-btn',
        cancelButton: 'btn dcb-btn',
      },
      confirmButtonText: confirmText,
      cancelButtonText: cancelText
    });
  }

export function insertPageBreaks(html: string): string {
  return html.replace(/<p>([2-9][0-9]*\.\s+)/g, '<div style="page-break-before: always;"></div><p>$1');
}


export function parseTermsIntoUnbreakableSections(htmlContent:any) {

  if (!htmlContent) {
    showErrorAlert(
      'No Terms and Conditions content found, Please Add it in the Subcontractor Agreement Settings',
      Swal
    );
    return [];
  }

  const pdfContent = htmlToPdfmake(htmlContent);

  const sections: any[] = [];
  let currentSection: any[] = [];

  const extractPlainText = (item: any): string => {
    if (!item) return '';

    // text is simple string
    if (typeof item.text === 'string') return item.text;

    // text may be an array → flatten recursively
    if (Array.isArray(item.text)) {
      return item.text.map(extractPlainText).join('');
    }

    return '';
  };

  const isHeading = (item: any): boolean => {
    const text = extractPlainText(item)
      .replace(/\u00a0+/g, ' ')   // replace &nbsp;
      .trim();

    // Matches: 1., 2., 10., 3.1, etc
    const headingRegex = /^\d+(\.\d+)*\./;

    return (
      item.bold === true ||        // from <strong>
      item.style === 'heading' ||
      headingRegex.test(text)
    );
  };

  pdfContent.forEach((item:any) => {

    if (isHeading(item)) {
      // push previous section
      if (currentSection.length > 0) {
        sections.push({ unbreakable: true, stack: currentSection });
      }

      // start new section with heading
      currentSection = [item];
    } else {
      currentSection.push(item);
    }
  });

  // push last section
  if (currentSection.length > 0) {
    sections.push({ unbreakable: true, stack: currentSection });
  }

  return sections;
}

// // REMOVE SIGNATURE FIELD
export function removeSignature(data:any): Promise<any> {
  const formValue = { ...data };

  // If no signature, return as is
  if (!formValue.signature) {
    return Promise.resolve(formValue);
  }

  // If signature is an http or blob link → REMOVE IT
  if (
    formValue.signature.startsWith('http') ||
    formValue.signature.startsWith('blob')
  ) {
    delete formValue.signature;   // ⬅️ Remove signature
    return Promise.resolve(formValue);
  }

  // If it's already base64, keep as is
  if (formValue.signature.startsWith('data:image')) {
    return Promise.resolve(formValue);
  }

  // Default fallback: remove signature
  delete formValue.signature;
  return Promise.resolve(formValue);
}

export function isBase64Image(value: string): boolean {
  return (
    typeof value === 'string' &&
    value.startsWith('data:image/') &&
    value.includes(';base64,')
  );
}
